/**
 * Converts a local date and time (in 24-hour format) to a UTC ISO string.
 *
 * The input is treated as wall-clock time in the browser's own system
 * timezone (`Intl.DateTimeFormat().resolvedOptions().timeZone`), since an
 * ISO date-time string with no offset is parsed by `Date` as local time per
 * the ECMAScript Date Time String Format spec — `toISOString()` then gives
 * the correctly shifted UTC instant.
 * @param {string} dateString - Date in 'YYYY-MM-DD' or 'YYYY-MM-DD HH:mm:ss' format
 * @param {string} [timeString] - Optional time in 'HH:mm' or 'HH:mm:ss' 24-hour format
 * @returns {string} UTC ISO string
 */
function ConvertDateTimeToUTC(dateString: string, timeString?: string): string {
  if (!dateString) {
    return '';
  }

  let datePart = dateString.trim();
  let timePart = timeString ? timeString.trim() : '';

  if (datePart.includes(' ')) {
    const parts = datePart.split(' ');
    [datePart] = parts;
    if (!timePart && parts[1]) {
      [, timePart] = parts;
    }
  }

  if (!timePart) {
    timePart = '00:00:00';
  }

  const fullTime = timePart.length === 5 ? `${timePart}:00` : timePart;
  const localDateTimeString = `${datePart}T${fullTime}`;

  const localDate = new Date(localDateTimeString);
  if (Number.isNaN(localDate.getTime())) {
    return '';
  }

  return localDate.toISOString();
}

export default ConvertDateTimeToUTC;
